import angular from 'angular';
import _ from 'lodash-es';
import { createNumberMask } from 'text-mask-addons';
import Utils from '~/scripts/services/utils';
import controller from './currency.controller';
import template from './currency.html';
import CurrencyComponent from './currency.component';

const currencyConfig = /* @ngInject */ (/** @type {any} */ KformComponentsProvider) => {
	KformComponentsProvider.register('currency', {
		title:      'Currency',
		template,
		group:      'advanced',
		tableView:  (/** @type {any} */ data, /** @type {any} */ options) => {
			if (_.isNil(data)) {
				return '';
			}

			const separators = Utils.getNumberSeparators();
			const { component } = options;
			const decimalLimit = component.decimalLimit || 2;
			// eslint-disable-next-line unicorn/consistent-destructuring
			const affixes = Utils.getCurrencyAffixes({
				currency:         component.currency,
				decimalLimit,
				decimalSeparator: separators.thousandsSeparator,
			});

			if (!component.delimiter) {
				separators.radix = '';
			}

			// eslint-disable-next-line unicorn/consistent-destructuring
			return options.util.formatNumber(data, createNumberMask({
				prefix:                   affixes.prefix,
				suffix:                   affixes.suffix,
				delimiter:                _.get(component, 'thousandsSeparator', separators.radix),
				decimalSymbol:            _.get(component, 'decimalSymbol', separators.thousandsSeparator),
				decimalLimit,
				allowNegative:            _.get(component, 'allowNegative', true),
				allowDecimal:             _.get(component, 'allowDecimal', true),
			}));
		},
		controller,
		icon:          'fa fa-usd',
		views:         [
			{
				name:     'Display',
				template: 'kform/components/currency/display.html',
			},
			{
				name:     'Data',
				template: 'kform/components/number/data.html',
			},
			{
				name:     'Validation',
				template: 'kform/components/common/validate.html',
			},
			{
				name:     'API',
				template: 'kform/components/common/api.html',
			},
			{
				name:     'Layout',
				template: 'kform/components/common/layout.html',
			},
			{
				name:     'Conditional',
				template: 'kform/components/common/conditional.html',
			},
			{
				name:     'Events',
				template: 'kform/components/common/events.html',
			},
		],
		children:   false,
		selectable: true,
		settings:   new CurrencyComponent(),
	});
};

export default angular.module('app').config(currencyConfig);
